<div class="container">
  <div class="text-left">
   
      <div class="breadcrumb flat">
          <a [routerLink]="['/pos']">
             
              Home
          </a>
          <a [routerLink]="['/pos/tender/manage']">Manage Tender</a>
          <a href="#" class="active"> View  Tender</a>
      </div>
  </div>
  <div class="content bg-light">
      <div class="container">
          <div class="row">
              <div class="col-md-12">
                  <div class="card card-outline-secondary">
                      <div class="card-header blue-bg">
                          <h4 class="mb-0">View Tender</h4>
                      </div>
                      <div class="card-body shadow right-img">
                       
                          <div class="row m-0">
                              <div class="col-md-7 bg-light cover">
                                  <div class="row border-bottom p-1 m-3">
                                      <div class="col-4 p-0"> Tender Name</div>
                                      <div class="col-1 col-lg-1  d-none d-md-block">:</div>
                                      <div class="col-7"> {{rows.TenderName}}</div>
                                  </div>
                                  <div class="row border-bottom p-1 m-3">
                                      <div class="col-4 p-0">Open Cash Drawer</div>
                                      <div class="col-1 col-lg-1  d-none d-md-block">:</div>
                                      <div class="col-7">
                                            <input type="checkbox"  [(ngModel)]="rows.OpenCashDrawer" id="OpenCashDrawer" name="OpenCashDrawer" >
                                          </div>
                                  </div>
                                  <div class="row border-bottom p-1 m-3">
                                      <div class="col-4 p-0">Tender Accepted</div>
                                      <div class="col-1 col-lg-1  d-nonsse d-md-block">:</div>
                                      <div class="col-7">
                                            <input type="checkbox"  [(ngModel)]="rows.TenderAccepted" id="TenderAccepted" name="TenderAccepted" > </div>
                                  </div>
                                 
                                  <div class="row border-bottom p-1 m-3">
                                    <div class="col-4 p-0"> Tender Type</div>
                                    <div class="col-1 col-lg-1  d-none d-md-block">:</div>
                                    <div class="col-7"> {{TenderType}}</div>
                                </div>
                                <div class="row border-bottom p-1 m-3">
                                    <div class="col-4 p-0">Date Time</div>
                                    <div class="col-1 col-lg-1  d-none d-md-block">:</div>
                                    <div class="col-7"> {{rows.DateTime | date:'d/M/yy, h:mm a'}}</div>
                                </div>
                               
                          
                                 
                                  <div class="text-right py-2">
                                      <!-- <button class=" damke_siteBtn" id="payButtonsList" [routerLink]="['/Coupon/ManageCoupons']">View Coupons</button>                                  -->
                                                                        </div>                                                            
                              </div>
                              <div class="col-md-5">
                                  <div class="col-12 col-md-10">
                                      <div class="border w-75  d-block mx-auto mx-md-0">
                                          <h4 class="blue-t py-2 text-center">Quick Links</h4>
                                          <ul class="list-group list-group-flush">
                                              <li class="list-group-item"><a [routerLink]="['/pos']">Home</a>
                                              </li>
                                              <li class="list-group-item"><a [routerLink]="['/pos/tender/new']">New Tender</a></li>

                                              <li class="list-group-item"><a [routerLink]="['/pos/tender/manage']">Manage Tender</a></li>
                                              <!-- <li class="list-group-item"><a [routerLink]="['/reports/transactions/summary']">Reports</a>
                                              </li> -->
                                          </ul>
                                      </div>
                                  </div>
                                  <div class="pt-2">
                                      <h4 class="blue-t p-2" style="font-family: 'Oswald', sans-serif;"></h4>
                                      <carousel [itemsPerSlide]="1" [singleSlideOffset]="false" [noWrap]="false" [interval]="3000" [startFromIndex]="0">

                                          <slide>
                                              <a [routerLink]="['/transactions/faqs']"><img src="assets/img/collecting-money.png" alt="First slide" style="display: block; width: 100%;"></a>
                                          </slide>
                                          <slide>
                                              <a [routerLink]="['/transactions/faqs']"><img src="assets/img/payment-solutions.png" alt="Third slide" style="display: block; width: 100%;"></a>
                                          </slide>
                                      </carousel>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>